<template>
		<v-card class="">
			<v-toolbar>                   
				<v-toolbar-title class="headline">               
					 Upload Photo
				</v-toolbar-title>                                            
				<v-spacer></v-spacer>
				<v-btn icon @click="setShowPhotoUpload(false)">
					<v-icon>close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-card-title class="headline px-4">{{selectedBuilding && selectedBuilding.name}} - {{selectedRoom && selectedRoom.number}}
			</v-card-title>

			<v-card-text class="px-4">
				<v-layout column>
					<v-flex class="mb-4" v-if="!imageName">
						The uploader can delete at any time.<br>
						Uploads subject to review before publicly viewable.
					</v-flex>
					<v-flex>
						<v-text-field
							v-show="!imageName && !loading"
							label="Select Image"
							@click="pickFile"
							v-model="imageName"
							prepend-icon="attach_file"
							ref="input"
							type="button">
						</v-text-field>
						<input
							type="file"
							style="display: none"
							ref="image"
							accept="image/*"
							@change="onFilePicked"/>							
					</v-flex>
<!-- NOT SURE THIS IS NEEDED.  Its a loading bar for the file-dialog.
It starts before file is picked, so it doesn't instill any additional confidence
<v-progress-linear height="20" class="mt-0" v-if="loading" color="blue" indeterminate>
						LOADING...
					</v-progress-linear> -->
					<v-layout column v-if="imageUrl">
						<v-img :src="imageUrl"></v-img>
						<v-layout row class="mt-3">						
							<v-flex offset-xs1 v-if="!showTags" @click="showTags=true" style="text-decoration: underline; cursor: pointer;">Add Tags</v-flex>
							<v-flex offset-xs1 v-else>Add Tags
								<v-icon small class="pl-1" color="red lighten-2"
										@click="clearTags">close</v-icon>
							</v-flex>
						</v-layout>
									
						<v-flex offset-xs1 v-if="showTags">
							<v-layout row>
								<v-flex xs6>
									<v-radio-group v-model="radioGroup">
								      <v-radio label="View of Front" value="Front"></v-radio>
								      <v-radio label="View of Back" value="Back"></v-radio>
								      <v-radio label="Layout" value="Layout"></v-radio>
									  <v-radio label="Sign" value="Sign"></v-radio>
								      <!-- MIGHT IMPLEMENT LATER -->
								      <!-- <v-radio label="Custom" value="Custom"></v-radio> -->
								    </v-radio-group>
								    <!-- <v-text-field box v-if="radioGroup=='Custom'" persistent-hint
										hint="Enter Tags, comma seperated" >
								    </v-text-field>	 -->
								</v-flex>
								<v-flex xs6>
								    <v-checkbox	v-model="pano" label="360 Pano"></v-checkbox>		
								</v-flex>
							</v-layout>		    
						</v-flex>
					</v-layout>	
				</v-layout>
				
			</v-card-text>
			<v-flex offset-xs1 class="pb-4">
				<v-progress-circular v-if="loading2" :size="30" color="primary" indeterminate></v-progress-circular>
				<v-btn dark color="#a70000" v-else-if="imageName" @click="fileUpload">
					Upload
				</v-btn>
				<v-btn color="green darken-1" class="ml-0" flat @click="resetForm">
					Cancel
				</v-btn>
			</v-flex>
		</v-card>
</template>

<script>
import Vuex from "vuex";
import { mapState, mapMutations, mapActions } from "vuex";

export default {
	name: "FileUpload",

	data() {
		return {
			imageName: null,
			imageUrl: "",
			imageFile: "",
			pano: false,
			radioGroup: null,
			showTags: false,
			loading: false,
			loading2: false,
			tags: null,
		};
	},

	mounted: function () {
		this.$refs.input.blur()		// This prevents mobile keyboard from popping up initially.
	},

	computed: {
		...mapState({
			showTestDialog: state => state.ui.showTestDialog,
			selectedRoom: state => state.space.selectedRoom,
			selectedBuilding: state => state.space.selectedBuilding,
		}),

		showPhotoUpload: {
			get() {
				return this.$store.state.ui.showPhotoUpload;
			},
			set(value) {
				this.setShowPhotoUpload(value);
			}
		}
	},

	methods: {
		...mapMutations([
			"setShowTestDialog",
			"setShowPhotoUpload",
			"setShowIndicatorPhotoReview"
		]),
		...mapActions(["uploadPhoto", "fetchFullRoom"]),

		clearTags: function() {
			this.showTags = false
			this.radioGroup = false
		},

		pickFile: function() {
			this.$refs.image.click();
			this.loading = true
		},

		onFilePicked(e) {
			this.loading = false
			console.log(e.target.files)
			const files = e.target.files;
			if (files[0] !== undefined) {
				this.imageName = files[0].name;
				if (this.imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					this.imageUrl = fr.result;
					this.imageFile = files[0]; // this is an image file that can be sent to server...
				});
			} else {
				this.resetForm();
			}
		},

		resetForm: function() {
			console.log("Reset Form")
			this.imageName = null
			this.imageFile = null
			this.imageUrl = null
			this.pano = false			
			this.radioGroup = null
			this.showTags = false
			this.loading = false
			this.loading2 = false
			this.tags = null
			this.setShowPhotoUpload(false)

		},

		fileUpload: function() {
			if (!this.imageFile) {
				console.log("No Photo Selected");
				return;
			}

			// Format Tag data
			if (this.radioGroup) {
				this.tags = []
				this.tags.push(this.radioGroup)
				console.log(this.tags)
			}

			var imageData;

			const vm = this;

			const toDataURL = url =>				
				fetch(url)
					.then(response => response.blob())
					.then(
						blob =>
							new Promise((resolve, reject) => {
								const reader = new FileReader();
								reader.onloadend = () => resolve(reader.result);
								reader.onerror = reject;
								reader.readAsDataURL(blob);
							})
					);

			toDataURL(this.imageUrl)
				.then(dataUrl => {
					//console.log('RESULT:', dataUrl)
					imageData = dataUrl;
					this.loading2 = true
					let payload = {
						room: this.selectedRoom.roomKey,
						pano: this.pano,
						tags: this.tags,
						image: imageData						
					}
					console.log(payload)
					this.uploadPhoto(payload)
					.then(() => {
						
						this.setShowIndicatorPhotoReview(1);
						vm.fetchFullRoom({
							bldgAlpha: this.selectedRoom.bldgAlpha,
							number: this.selectedRoom.number
						})
						.then(() => { this.resetForm() })
						
					});
				})
				
		}
	}
};
</script>

<style>
.cardtext > .v-list__tile {
	height: 40px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/forms/PhotoUploadContent.vue